import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/main.css';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from "./sections/Home";
import Portfolio from "./sections/Portfolio";
import Services from "./sections/Services";
import Contact from "./sections/Contact";
import React from 'react';
import PageNotFound from './sections/PageNotFound';
import DesignPortfolio from './sections/DesignPortfolio';


function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="contact" element={<Contact />} />
        <Route path="portfolio" element={<Portfolio />} />
        <Route path="services" element={<Services />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
      <Route path="portfolio/design" element={<DesignPortfolio />} />
      <Route path="portfolio/design/:id" element={<DesignPortfolio />} />
    </Routes>
  );
}

export default App;
